import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M42.85 39.509 28 54l-14.85-14.491a20.74 20.74 0 0 1-5.748-10.65A20.6 20.6 0 0 1 8.6 16.84c1.59-3.8 4.28-7.049 7.734-9.335A21.14 21.14 0 0 1 28 4c4.153 0 8.213 1.22 11.667 3.505A20.85 20.85 0 0 1 47.4 16.84a20.6 20.6 0 0 1 1.196 12.018 20.74 20.74 0 0 1-5.747 10.65"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M21 24a7 7 0 1 0 14 0 7 7 0 0 0-14 0"
    }, null, -1)
  ]))]))
}
export default { render: render }